import { render, staticRenderFns } from "./TrackMetadataTab.vue?vue&type=template&id=301ce48c&scoped=true"
import script from "./TrackMetadataTab.vue?vue&type=script&lang=js"
export * from "./TrackMetadataTab.vue?vue&type=script&lang=js"
import style0 from "./TrackMetadataTab.vue?vue&type=style&index=0&id=301ce48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ce48c",
  null
  
)

export default component.exports